<template>
    <b-button variant="outline-primary" size="sm" @click="changeSecretNoInput" v-b-tooltip.hover.topright :title="tooltip">
      <b-icon :animation="isSpinEnabled ? 'spin' : ''" icon="arrow-clockwise"></b-icon>
    </b-button>
</template>

<script>
import unitsApi from "@/services/unitApi";
import store from "@/store/store";
import userApiService from "@/services/userApiService";

export default {
  name: "ChangeSecretButtonNoInput",
  props: {
    changeType: String,
    tooltip: String
  },
  data() {
    return {
      isSpinEnabled: false
    }
  },
  methods: {
    showToast() {
       this.isSpinEnabled = false;
       const h = this.$createElement
       const id = `secretChange-toast-${this.count++}`

       const $closeButton = h(
         'b-button',
         {
           on: { click: () => {
            this.$bvToast.hide(id);
            if(this.changeType === 'IDENTITY') {
              store.dispatch("reloadSelectedUserFromApi")
            } else {
              store.dispatch("loadUnitInformationFromApi")
            }
          }}
         },
         'Close'
       )

       this.$bvToast.toast([this.$t('secretChange.successfulSecretUpdate'),$closeButton], {
          id: id,
          title: this.$t('secretChange.secretUpdateTitle'),
          noAutoHide: true,
          toaster: "b-toaster-top-center",
          variant: "success",
          append: false,
          solid: false,
          noCloseButton: true
        })
    },
    async changeSecretNoInput() {
      this.isSpinEnabled = true;
      const isDpskPassphraseLengthEnforced = store.getters.isDpskPassphraseLengthEnforced
      if(this.changeType === 'IDENTITY') {
        await this.changeIdentityPassphrase()
      } else if(this.changeType === "GUEST") {
        if(isDpskPassphraseLengthEnforced === true){
          await this.changeUnitPassphrase({guestSecret: ""})
        } else {
          await this.changeUnitPassphrase({guestSecret: unitsApi.generateRandomPassphrase()})
        }
      } else {
        if(isDpskPassphraseLengthEnforced === true){
          await this.changeUnitPassphrase({secret: ""})
        } else {
          await this.changeUnitPassphrase({secret: unitsApi.generateRandomPassphrase()})
        }
      }

    },
    async changeIdentityPassphrase() {
      try {
        await userApiService.updateIdentityPassphrase(store.getters.getSelectedUserId, store.getters.getSelectedUserName, "")
        this.showToast()
      } catch(e) {
        this.isSpinEnabled = false;
        if (e.response.status === 400) {
          this.$bvToast.toast(e.response.data.message, {
            title: this.$t('secretChange.errorChangingPassphraseTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        } else {
          this.$bvToast.toast(this.$t('secretChange.errorChangingPassphrase'), {
            title: this.$t('secretChange.errorChangingPassphraseTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        }
      }
    },
    async changeUnitPassphrase(unit) {
      try {
        await unitsApi.updateUnit(store.getters.getTenantGuid, unit)
        this.showToast()
      } catch(e) {
        this.isSpinEnabled = false;
        if (e.response.status === 409) {
          this.$bvToast.toast(this.$t('secretChange.invalidSecretMsg'), {
            title: this.$t('secretChange.invalidSecretTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        } else if (e.response.status === 400) {
          this.$bvToast.toast(e.response.data.message, {
            title: this.$t('secretChange.errorChangingPassphraseTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        } else {
          this.$bvToast.toast(this.$t('secretChange.errorChangingPassphrase'), {
            title: this.$t('secretChange.errorChangingPassphraseTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
